import React, { useState } from 'react';
import { Button } from 'antd';
import { PrinterOutlined } from '@ant-design/icons';
import PermissionGuard from '../../components/PermissionGuard';
import { Modules } from '../../constants/permissions';
import { usePW1312Query } from './hooks/usePW1312Query';
import QueryParamsPanel from './components/QueryParams';
import ResultTable from './components/ResultTable';
import type { QueryParams } from '../../services/pw1312Api';
import './PW1312Form.css';

const PW1312Form: React.FC = () => {
  const { loading, data, queried, noData, runQuery, reset } = usePW1312Query();
  const [codeFrom, setCodeFrom] = useState('');
  const [codeTo, setCodeTo] = useState('');

  const handleQuery = () => {
    const params: QueryParams = {
      codeFrom: codeFrom.trim() || undefined,
      codeTo: codeTo.trim() || undefined,
    };
    runQuery(params);
  };

  const handleReset = () => { setCodeFrom(''); setCodeTo(''); reset(); };

  const handlePrint = () => {
    if (!data || data.length === 0) return;
    const win = window.open('', '_blank');
    if (!win) return;
    const now = new Date().toLocaleString('zh-TW');
    win.document.write(`<!DOCTYPE html><html><head><title>工繳清冊</title>
<style>body{font-family:'Microsoft JhengHei',sans-serif;margin:20px;font-size:12px;}
h2{text-align:center;}table{width:100%;border-collapse:collapse;}th,td{border:1px solid #333;padding:4px 8px;}
th{background:#f0f0f0;text-align:center;}@media print{body{margin:10mm;}}</style></head><body>
<h2>工繳清冊</h2><div style="text-align:center;font-size:11px;color:#555;margin-bottom:12px;">列印時間: ${now}</div>
<table><thead><tr><th>工繳代號</th><th>備忘1</th><th>備忘2</th></tr></thead><tbody>
${data.map(r => `<tr><td>${r.code}</td><td>${r.memo1}</td><td>${r.memo2}</td></tr>`).join('')}
</tbody></table></body></html>`);
    win.document.close(); win.focus(); win.print();
  };

  return (
    <PermissionGuard module={Modules.PW1312} action="query">
      <div className="pw1312-container">
        <div className="pw1312-header">
          <h2>工繳清冊</h2>
          <div className="pw1312-print-btn">
            {queried && !noData && <Button icon={<PrinterOutlined />} onClick={handlePrint}>列印</Button>}
          </div>
        </div>
        <QueryParamsPanel codeFrom={codeFrom} codeTo={codeTo} loading={loading}
          onCodeFromChange={setCodeFrom} onCodeToChange={setCodeTo}
          onQuery={handleQuery} onReset={handleReset} />
        <ResultTable data={data} loading={loading} queried={queried} noData={noData} />
      </div>
    </PermissionGuard>
  );
};

export default PW1312Form;
